/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Provision_ExpectedInputs */

const cs_reports_col_provision_expected = /** @type {(inputs: Reports_Col_Provision_ExpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávaná`)
};

const en_reports_col_provision_expected = /** @type {(inputs: Reports_Col_Provision_ExpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected`)
};

/**
* | output |
* | --- |
* | "Expected" |
*
* @param {Reports_Col_Provision_ExpectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_provision_expected = /** @type {((inputs?: Reports_Col_Provision_ExpectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Provision_ExpectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_provision_expected(inputs)
	return cs_reports_col_provision_expected(inputs)
});